<template>
  <b-modal
    id="pro-feature-modal"
    v-model="isOpen"
    title="PRO Feature"
    centered
    hide-footer
    @close="closeModal()"
  >
    <div class="text-center p-5">
      <form @submit.prevent="handleSubmit">
        <div class="signUpFormHeader field">
          <p>
            Complete the form, we will review your request and contact you
            shortly.
          </p>
        </div>
        <BaseInput
          v-model="authUserData.email"
          custom-size="xlarge"
          type="email"
          placeholder="some@example.com"
          required
          readonly
          label="Your Email*"
          class="field"
        />
        <div class="columns field">
          <BaseInput
            v-model="formChild.name"
            class="column"
            style="width: 48%"
            custom-size="xlarge"
            type="text"
            placeholder="Enter your first name"
            label="Your First Name *"
            required
            @blur.native="$v.formChild.name.touch()"
          />
          <BaseInput
            v-model="formChild.lastName"
            class="column"
            style="width: 48%"
            custom-size="xlarge"
            type="text"
            placeholder="Enter your last name"
            required
            label="Your Last Name *"
          />
        </div>
        <BaseInput
          v-model="formChild.company"
          custom-size="xlarge"
          type="text"
          placeholder="Enter your company name"
          required
          label="Company*"
          class="field"
        />
        <BaseTextarea
          v-model="formChild.description"
          placeholder="Enter your message"
          label="Your Message"
          class="mb-5"
        />
        <b-field>
          <BaseButton
            :disabled="disabledButton"
            :loading="loading"
            size="xlarge"
            ><p slot="text">Send</p>
            <p
          /></BaseButton>
        </b-field>
      </form>
    </div>
  </b-modal>
</template>

<script>
import BackgroundWrapper from "@/components/_shared/BackgroundWrapper.vue";
import SignUpForm from "@/components/sign-up/SignUpForm.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import BaseTextarea from "@/components/base-ui/BaseTextarea.vue";
import BaseInput from "@/components/base-ui/BaseInput.vue";
import { mapGetters } from "vuex";

export default {
  name: "UpgradeProModal",
  components: {
    BaseInput,
    BaseTextarea,
    BaseButton,
    BackgroundWrapper,
    SignUpForm,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      isOpen: this.isModalOpen,
      errorMessage: null,
      formChild: {
        name: "",
        lastName: "",
        company: "",
        description: "",
      },
    };
  },
  watch: {
    authUserData: {
      immediate: true,
      handler(user) {
        this.formChild.name = user.name;
      },
    },
    isModalOpen(newValue) {
      this.isOpen = newValue;
    },
  },
  computed: {
    ...mapGetters({
      authUserData: "auth/getAuthUserData",
    }),
    disabledButton() {
      return !(
        this.formChild.name !== "" &&
        this.formChild.lastName !== "" &&
        this.formChild.company !== "" &&
        this.formChild.description !== ""
      );
    },
  },
  methods: {
    async handleSubmit() {
      this.loading = true;

      const response = await this.$store.dispatch("users/sendContactUs", {
        first_name: this.formChild.name,
        last_name: this.formChild.lastName,
        email: this.authUserData.email,
        subject: "MESSAGE FROM UPGRADE PRO",
        description: this.formChild.description ?? "",
        company: this.formChild?.company ?? "",
      });

      if (response.data) {
        this.$buefy.toast.open({
          duration: 5000,
          message: response.data.message,
          position: "is-top",
          type: "is-success",
        });
      }

      this.loading = false;

      this.closeModal();
    },
  },
};
</script>
